export default __webpack_public_path__ + "static/RENDER COMP (1280x1024)-e6b615b068cd55ceb2f37be9817ca7e4.mp4";